import { PaletteColor } from '@mui/material';

export const babyBluePaletteColor: PaletteColor = {
  light: '#cfe9fc',
  main: '#9ed4f8',
  dark: '#6ca3c5',
  contrastText: '#000000',
};
